import { Link } from "react-router-dom";
import { Instagram, Youtube, Phone, MessageCircle } from "lucide-react";
import { LogoBadge } from "./Logo";
import Marquee from "./Marquee";

const SOCIALS = [
  { icon: Instagram, label: "@choices_anddecisions", href: "https://instagram.com/choices_anddecisions", testid: "social-ig-choices" },
  { icon: Instagram, label: "@listen_adolescents", href: "https://instagram.com/listen_adolescents", testid: "social-ig-listen" },
  { icon: Youtube, label: "Listen Television Network", href: "https://youtube.com/@ListenTelevisionNetwork", testid: "social-youtube" },
];

const CONTACTS = [
  { icon: Phone, label: "+233 54 608 0065", href: "tel:+233546080065", testid: "contact-phone" },
  { icon: MessageCircle, label: "Chat on WhatsApp", href: "https://wa.me/233546080065?text=Hello%20Choices%20%26%20Decisions!%20I'd%20love%20to%20know%20more.", testid: "contact-whatsapp" },
];

export default function Footer() {
  return (
    <footer className="relative bg-[#1B0812] text-cream overflow-hidden">
      <div className="py-10 border-b border-white/10">
        <Marquee text="Believe. Become. Lead." variant="light" animClass="animate-marquee-slow" />
      </div>

      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-[1.6fr_1fr_1.2fr_1.2fr]">
        <div>
          <LogoBadge />
          <p className="mt-5 max-w-sm font-serif text-2xl leading-snug text-cream/85">
            Where purpose finds a voice. Every decision creates a legacy.
          </p>
        </div>

        <div>
          <p className="font-display text-xs uppercase tracking-[0.2em] text-coral mb-4">Explore</p>
          <ul className="space-y-3 font-sans text-sm text-cream/70">
            <li><Link to="/movement" className="hover:text-cream transition-colors" data-testid="footer-movement">The Movement</Link></li>
            <li><Link to="/journey" className="hover:text-cream transition-colors" data-testid="footer-journey">Our Journey</Link></li>
            <li><Link to="/voices" className="hover:text-cream transition-colors" data-testid="footer-voices">Voices</Link></li>
            <li><Link to="/gather" className="hover:text-cream transition-colors" data-testid="footer-gather">The Gathering</Link></li>
            <li><Link to="/gallery" className="hover:text-cream transition-colors" data-testid="footer-gallery">Gallery</Link></li>
            <li><Link to="/conference" className="hover:text-cream transition-colors" data-testid="footer-conference">Register for Conference</Link></li>
            <li><Link to="/register" className="hover:text-cream transition-colors" data-testid="footer-register">Register / Sponsor</Link></li>
          </ul>
        </div>

        <div>
          <p className="font-display text-xs uppercase tracking-[0.2em] text-coral mb-4">Follow the Movement</p>
          <ul className="space-y-3 font-sans text-sm text-cream/70">
            {SOCIALS.map((s) => {
              const Icon = s.icon;
              return (
                <li key={s.testid}>
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={s.testid}
                    className="group inline-flex items-center gap-3 hover:text-cream transition-colors"
                  >
                    <span className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 group-hover:border-coral group-hover:text-coral transition-colors">
                      <Icon size={16} />
                    </span>
                    {s.label}
                  </a>
                </li>
              );
            })}
          </ul>

          <p className="font-display text-xs uppercase tracking-[0.2em] text-coral mt-8 mb-4">Talk to Us</p>
          <ul className="space-y-3 font-sans text-sm text-cream/70">
            {CONTACTS.map((c) => {
              const Icon = c.icon;
              return (
                <li key={c.testid}>
                  <a
                    href={c.href}
                    target={c.href.startsWith("http") ? "_blank" : undefined}
                    rel="noopener noreferrer"
                    data-testid={c.testid}
                    className="group inline-flex items-center gap-3 hover:text-cream transition-colors"
                  >
                    <span className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 group-hover:border-coral group-hover:text-coral transition-colors">
                      <Icon size={16} />
                    </span>
                    {c.label}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>

        <div>
          <p className="font-display text-xs uppercase tracking-[0.2em] text-coral mb-4">The Invitation</p>
          <p className="font-sans text-sm leading-relaxed text-cream/70">
            The future is not waiting for someone else. It is waiting for this generation — one conversation, one decision, one young woman at a time.
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-cream/40 font-sans">
        <span>© {new Date().getFullYear()} Choices &amp; Decisions. A movement for the next generation.</span>
        <span className="tracking-[0.2em] uppercase">Prepared, not predicted.</span>
      </div>
    </footer>
  );
}
